// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__k98yr","colMaxWidth":"Table_colMaxWidth__3pr2U"};